// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1f7mp","inputWrap":"Table_inputWrap__3EEy6","col":"Table_col__38Xnl","bmiTooltip":"Table_bmiTooltip__2XvKX"};